import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css/normalize.css';

import './styles/milligram.css';
import './styles/custom-miligram.css';
import { unregister } from './registerServiceWorker';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
unregister();
